import React, { useEffect, useRef, useState } from "react";
import { Html5QrcodeScanner } from "html5-qrcode";
import { PURCHASE_API } from "../../apiConfig";

const ScanGRN = () => {
  const scannerRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [grnData, setGrnData] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    if (scannerRef.current) return;

    scannerRef.current = new Html5QrcodeScanner(
      "reader",
      {
        fps: 10,
        qrbox: {
          width: 250,
          height: 250,
        },
      },
      false
    );

    scannerRef.current.render(onScanSuccess, onScanFailure);

    return () => {
      if (scannerRef.current) {
        scannerRef.current
          .clear()
          .catch(() => {});
      }
    };
  }, []);

  const onScanSuccess = async (decodedText) => {
    try {
      scannerRef.current.clear();

      setLoading(true);
      setError("");

      const grnNo = decodedText.trim();

      const res = await fetch(
        `${PURCHASE_API}/goods-receipt/view/by-grn/${grnNo}`
      );

      const data = await res.json();

      if (!Array.isArray(data) || data.length === 0) {
        setError("GRN not found");
        setGrnData([]);
      } else {
        setGrnData(data);
      }
    } catch (err) {
      console.error(err);
      setError("Unable to fetch GRN");
    } finally {
      setLoading(false);
    }
  };

  const onScanFailure = () => {
    // ignore
  };

  return (
    <div
      style={{
        width: "95%",
        margin: "30px auto",
      }}
    >
      <h2
        style={{
          textAlign: "center",
          marginBottom: "20px",
        }}
      >
        Scan GRN
      </h2>

      {grnData.length === 0 && (
        <div
          id="reader"
          style={{
            width: "450px",
            margin: "auto",
          }}
        />
      )}

      {loading && (
        <h4
          style={{
            textAlign: "center",
            color: "blue",
          }}
        >
          Loading...
        </h4>
      )}

      {error && (
        <h4
          style={{
            textAlign: "center",
            color: "red",
          }}
        >
          {error}
        </h4>
      )}

      {grnData.length > 0 && (
        <div
          style={{
            marginTop: "30px",
          }}
        >
          <h3>GRN Details</h3>

          <table
            border="1"
            cellPadding="8"
            style={{
              width: "100%",
              borderCollapse: "collapse",
            }}
          >
            <thead>
              <tr>
                <th>GRN No</th>
                <th>Product Code</th>
                <th>Description</th>
                <th>Batch</th>
                <th>Quantity</th>
                <th>Supplier</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {grnData.map((item, index) => (
                <tr key={index}>
                  <td>{item.grn_number}</td>
                  <td>{item.product_code}</td>
                  <td>{item.description}</td>
                  <td>{item.batch_number}</td>
                  <td>{item.received_qty}</td>
                  <td>{item.vendor_name}</td>
                  <td>{item.status}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div
            style={{
              textAlign: "center",
              marginTop: "20px",
            }}
          >
            <button
              className="btn btn-primary"
              onClick={() => {
                setGrnData([]);
                setError("");

                scannerRef.current = null;

                setTimeout(() => {
                  scannerRef.current = new Html5QrcodeScanner(
                    "reader",
                    {
                      fps: 10,
                      qrbox: {
                        width: 250,
                        height: 250,
                      },
                    },
                    false
                  );

                  scannerRef.current.render(
                    onScanSuccess,
                    onScanFailure
                  );
                }, 100);
              }}
            >
              Scan Another GRN
            </button>
          </div>

          <div
            id="reader"
            style={{
              width: "450px",
              margin: "30px auto",
            }}
          />
        </div>
      )}
    </div>
  );
};

export default ScanGRN;